import Toasted from 'vue-toasted';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import BuildingListing from './components/BuildingListing';

Vue.config.productionTip = false;

Vue.use(VueI18n);

Vue.use(Toasted, {
  duration: 3000,
  keepOnHover: true,
  position: "top-center"
});

// eslint-disable-next-line no-undef
const translations = wpData.translations || {}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: translations,
  silentFallbackWarn: true
})

new Vue({
  i18n,
  render: (h) => h(BuildingListing),
}).$mount('#vue-building-listing');

